import React, { useState } from 'react';
import { message } from 'antd';
import queryString from 'query-string';
import cookies from 'js-cookie';
import { cookieNames } from '~client/constants/storage';
import { useApolloClient } from '@apollo/client';
import { MUTATION_AGENTLOGIN, MUTATION_AGENTSIGUP } from './queries';
import { Hosts } from '~helpers/environments';
import { getCookieDomain } from '~helpers/login-utils';
import SignupOrLogin from './signup-login';
import SignupAgent from './sign-up';
import AgentLoginbyEmail from './login';
import { useTranslation } from 'react-i18next';
import event from '~helpers/mixpanel';
import jwtDecode from 'jwt-decode';

export const AgentLogin = () => {
  const search = queryString.parse(location.search);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState('signUpOrLogin');
  const [email, setEmail] = useState();

  const client = useApolloClient();
  const handleLinkToken = token => {
    if (token) {
      cookies.set(cookieNames.agentToken, token, {
        path: '/',
        expires: 2,
        domain: getCookieDomain(),
      });
      if (search.redirect_to) {
        window.location.href = `${decodeURIComponent(search.redirect_to)}${token}`;
      } else {
        window.location.href = `${Hosts.agentUrl}/#/`;
      }
    }
  };
  const loginProcess = (values, callback) => {
    setLoading(true);

    client
      .mutate({
        mutation: MUTATION_AGENTLOGIN,
        variables: {
          input: {
            email: values.email,
            password: values.password,
          },
        },
      })
      .then(r => {
        let token = r?.data?.agentLogin?.authToken;
        const info = jwtDecode(token);
        if (info && info.uuid) {
          event('Login Success', {
            'User Role': 'Agent',
            'Current Page Type': 'Signup-Login',
            'Page Name': 'Signup-Login | Login',
            'Email Address': values.email,
            uuid: info.uuid,
          });
        }
        handleLinkToken(token);
      })
      .catch(e => {
        const errMessage = e.message;
        if (errMessage && errMessage.includes('INVALID_CREDENTIALS')) {
          callback(t('sorry_the_password_and_email_does_not_match'));
          return;
        } else {
          message.error(errMessage);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const signUpProcess = values => {
    setLoading(true);
    client
      .mutate({
        mutation: MUTATION_AGENTSIGUP,
        variables: {
          input: {
            email: values.email,
            password: values.password,
            newsletterAccepted: false,
          },
        },
      })
      .then(r => {
        let token = r?.data?.agentSignUp?.authToken;
        const info = jwtDecode(token);
        if (info && info.uuid) {
          event('Signup Success', {
            'User Role': 'Agent',
            'Current Page Type': 'Signup-Login',
            'Page Name': 'Signup-Login | Signup',
            'Email Address': values.email,
            uuid: info.uuid,
          });
        }
        handleLinkToken(token);
      })
      .catch(e => {
        message.error(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleContinueEvent = e => {
    if (e?.checkUserExist?.exist) {
      setCurrentStep('login');
      event('Viewed Login Page', {
        'Current Page Type': 'Signup-Login',
        'User Role': 'Agent',
        'Page Name': 'Signup-Login | Login',
      });
    } else {
      setCurrentStep('signUp');
      event('Viewed Signup Page', {
        'Current Page Type': 'Signup-Login',
        'User Role': 'Agent',
        'Page Name': 'Signup-Login | Signup',
      });
    }
  };

  return (
    <>
      <If condition={currentStep === 'signUpOrLogin'}>
        <SignupOrLogin
          handleNextContent={handleContinueEvent}
          setEmail={emailAddress => {
            setEmail(emailAddress);
          }}
        />
      </If>
      <If condition={currentStep === 'signUp'}>
        <SignupAgent
          loading={loading}
          loginEmail={email}
          handleNextContent={signUpProcess}
          handleBackEvent={() => {
            setCurrentStep('signUpOrLogin');
          }}
        />
      </If>
      <If condition={currentStep === 'login'}>
        <AgentLoginbyEmail
          loginEmail={email}
          handleNextContent={(e, callback) => {
            loginProcess(e, callback);
          }}
          loading={loading}
          handleBackEvent={() => {
            setCurrentStep('signUpOrLogin');
          }}
        />
      </If>
    </>
  );
};

export default AgentLogin;
